import { Box, Button, Dialog, Grid, IconButton, LinearProgress, Typography, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import useCategoryBranchController from './controller';
import Delete_IC from '../../assets/images/logo/delete_ic.svg'
import { IMAGE_CATEGORY_ROOT_URL } from '../../constants/imageUrl';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SearchNotFound from '../../components/searchNotFound';
import { SuppliesMainGroupName } from '../../models/suppliesMain';
import { MainCategoryForm } from './FormMainGroup';
import SearchIcon from '@mui/icons-material/Search';
import ConfirmDialog from '../../components/ConfirmDialog';
import { MerChantModel } from '../../models/merChantModel';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import { useTranslation } from 'react-i18next';
import { MainGroupModel } from '../../models/mainGroup';
import MainGroup from './MainGroup';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import SelectedBranchComponents from '../../components/SelectedBranch';

const CategoryBranchView = () => {
  const { i18n } = useTranslation("global");
  const controller = useCategoryBranchController();
  const { t } = useTranslation('global')

  return (
    <>
      {
        !controller.loading ?
          <>
            {
              controller.openForm ?
                <Box sx={{ overflow: 'auto', height: 'auto' }}>
                  <MainGroup merchantId={controller.merchant} onClose={controller.handleCloseForm} mainGroupData={controller.selectedMainGroup} />
                </Box>
                :
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
                      <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}> {t("merchant_categories.Merchant Categories")} </Typography>
                      {/* <FormControl fullWidth sx={{ mb: 2, maxWidth: 250 }} size="small">
                        <InputLabel id="merchant-label-id" shrink={true}>{t("merchant_categories.Merchant")}</InputLabel>
                        <Select
                          labelId="merchant-label-id"
                          id="merchant-id"
                          value={controller.merchant}
                          label="Merchant"
                          onChange={controller.handleMerchantChange}
                          sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                        >
                          {
                            controller.dataMerchants?.map((item: MerChantModel) => <MenuItem key={item?.id} value={item?.id}>{i18n.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}</MenuItem>)
                          }
                        </Select>
                      </FormControl> */}
                      <SelectedBranchComponents value={controller.merchant} onSelectMerchant={controller.handleMerchantChange} merchantData={controller.dataMerchants}/>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%', justifyContent: 'space-between' }}>
                      <Typography variant='h5' fontWeight='bold' color={TEXT_TITLE_COLOR}>
                        {t("merchant_categories.All Main category")} ({controller.filterData.length})
                      </Typography>
                      {/* <Box>
                        <Button variant='contained' color='secondary' onClick={controller.handleOpenAddCategory} sx={{ textTransform: 'none', color: '#fff' }}>
                          <AddIcon />
                          &nbsp;
                          Create new category
                        </Button>
                      </Box> */}
                    </Box>
                  </Box>
                  <Grid container spacing={2} mt={1} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                      controller.filterData.map((cat: MainGroupModel) => (
                        <Grid item xs={12} sm={6} md={3} key={cat.id} >
                          <Box sx={{
                            minHeight: 200, p: 2, borderRadius: '16px', width: 'auto', height: 'auto', boxShadow:
                              '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            background: '#f5fcff'
                          }}>
                            <Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <img src={IMAGE_CATEGORY_ROOT_URL + cat?.supplies_main_group_name?.icon?.url} style={{ width: '40px', height: '40px' }} alt="" />
                                <Box>
                                  <IconButton onClick={() => controller.handleOpenForm(cat?.id)}>
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                  {/* <IconButton onClick={() => controller.handleOpenDelete(cat?.id)}>
                                    <img src={Delete_IC} style={{ width: '20px', height: '20px' }} alt="" />
                                  </IconButton> */}
                                </Box>
                              </Box>
                              <Box mt={2}>
                                <Typography fontWeight='bold'>MG.code : {cat?.supplies_main_group_name?.code}</Typography>
                                <Typography fontWeight='bold'>MG {t("merchant_categories.eng name")}: <span style={{ color: 'grey' }}>{cat?.supplies_main_group_name?.main_group_name_en}</span></Typography>
                                <Typography fontWeight='bold'>MG lao{t("merchant_categories.lao name")}: <span style={{ color: 'grey' }}>{cat?.supplies_main_group_name?.main_group_name_la}</span></Typography>
                                <Typography fontWeight='bold'>{t("merchant_categories.Branch")}: <span style={{ color: 'grey' }}>{i18n.language === EN_ACCEPT_LANGUAGE ? controller.dataMerchants?.filter((merchant: MerChantModel) => merchant?.id === cat?.merchant_id)[0]?.nameEn : controller.dataMerchants?.filter((merchant: MerChantModel) => merchant?.id === cat?.merchant_id)[0]?.nameLa}</span></Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                  {
                    controller.isSearchNotFound && (
                      <SearchNotFound searchValue={controller.searchValue} />
                    )
                  }
                  <ConfirmDialog
                    open={controller.openDeleteForm}
                    title='Do you want to delete this data ?'
                    loading={controller.loadingButtonDelete}
                    onCancel={controller.handleCloseDeleteForm}
                    onConfirm={controller.handleDelete}
                  />
                  <Box>
                    <Dialog
                      fullWidth
                      maxWidth={'lg'}
                      open={controller.openMainCategory}
                    >
                      <MainCategoryForm

                        merchant={{
                          id: controller.merchant,
                          label: i18n.language === EN_ACCEPT_LANGUAGE ? controller.dataMerchants.filter((item) => item?.id === controller.merchant)[0]?.nameEn : controller.dataMerchants.filter((item) => item?.id === controller.merchant)[0]?.nameLa
                        }}
                        onClose={controller.handleCloseAddCategory}
                        onRefetchData={controller.handleRefetchData}
                        selectedMain={controller.selectedMainCategoryId}
                        dataMasterMainGroup={controller.dataMasterMainGroup}
                      />
                    </Dialog>
                  </Box>
                </Box>
            }
          </>

          :
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingAnimatedIcon />
          </Box>
      }
    </>
  );
};
export default CategoryBranchView;